// extracted by mini-css-extract-plugin
module.exports = {"icons":"PaypalPaymentBlockIcons_icons_23_iY"};